import { toast } from "react-toastify";

// Fake backend helper functions
export const postFakeLogin = async (data: any) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Mock response
  return {
    user: {
      mobile_number: data.mobile_number || "+919876543210",
      first_name: "Test",
      last_name: "User",
      points: 0
    },
    tokens: {
      access: "fake_access_token",
      refresh: "fake_refresh_token"
    }
  };
};

export const postFakeProfile = async (data: any) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, data };
};

export const postFakeRegister = async (data: any) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, message: "Registration successful" };
};